import 'photoswipe/dist/photoswipe.css';
import 'photoswipe/dist/default-skin/default-skin.css';
import photoswipeComponentUrl from './photoswipeComponent.html';

export default {
  templateUrl: photoswipeComponentUrl,
};
